<template>
  <b-input-group>
    <v-text-field
      ref="autofocus"
      autocomplete="off"
      :type="show_password ? 'text' : 'password'"
      :disabled="disabled"
      :loading="loading"
      :dense="dense"
      :outlined="outlined"
      :label="label"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      :value="value"
      @input="evOnInput"
      @change="evOnChange"
    />
    <template #append>
      <button
        variant="info"
        type="button"
        class="btn-show-password"
        :disabled="disabled"
        @click.stop="evOnTypeChange"
      >
        <b-icon :icon="show_password ? 'eye-slash' : 'eye'" />
      </button>
    </template>
  </b-input-group>
</template>

<script>
export default {
  name: "VTextFieldPassword",
  props: {
    value: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    dense: { type: Boolean, default: true },
    outlined: { type: Boolean, default: true },
    label: { type: String, default: "Senha" },
    placeholder: { type: String, default: "" },
    hideDetails: { type: Boolean, default: true },
  },
  data() {
    return {
      show_password: false,
    };
  },
  methods: {
    async evOnInput(value) {
      this.$emit("input", value);
    },

    async evOnChange(value) {
      this.$emit("change", value);
    },

    async evOnTypeChange() {
      this.show_password = !this.show_password;
      this.$emit("typechange", this.show_password);
    },

    async focus() {
      this.$refs.autofocus.focus();
    },
  },
};
</script>

<style>
</style>